module.exports = __webpack_public_path__ + "img/filter.7d62d2ca.svg";